// extracted by mini-css-extract-plugin
module.exports = {"container":"_1tPq-2-","bagTitle":"_1ovivM0"};